import axios from 'axios';
import router from '@/router';
import { db } from '@/sunidhiapp';

var cachedLoginUserId = null;

/* =====================================================
   HELPERS
===================================================== */
export function setLoginUserId(userId) {
  cachedLoginUserId = userId;
}

export function clearLoginSession() {
  cachedLoginUserId = null;
  localStorage.clear();
  sessionStorage.clear();
}

/* =====================================================
   REQUEST INTERCEPTOR
   → add PWADSAUserId header
   → SKIP login API
===================================================== */
axios.interceptors.request.use(
  function (config) {
    try {
      //  Skip header for login API
      if (
        config.url &&
        config.url.indexOf('DSALoginAuthentication_check') !== -1
      ) {
        return config;
      }

      // Load once from IndexedDB
      if (!cachedLoginUserId) {
        return db.TbGenz
          .where('UserId')
          .anyOf(1)
          .toArray()
          .then(function (genzdata) {
            if (
              genzdata &&
              genzdata.length > 0 &&
              genzdata[0] &&
              genzdata[0].DSAUserId
            ) {
              cachedLoginUserId = genzdata[0].DSAUserId;
            }

            if (cachedLoginUserId) {
              config.headers.DSAUserId = cachedLoginUserId;
            }

            return config;
          });
      }

      // Use cached value
      if (cachedLoginUserId) {
        config.headers.DSAUserId = cachedLoginUserId;
      }
    } catch (e) {
      // ignore
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

/* =====================================================
   RESPONSE INTERCEPTOR
   → duplicate session (81)
===================================================== */
axios.interceptors.response.use(
  function (response) {
    var status = null;

    if (
      response &&
      response.data &&
      response.data.DSAAuthenticationStatus
    ) {
      status = String(response.data.DSAAuthenticationStatus);
    }

    if (status === '81') {
      var handled =
        sessionStorage.getItem('DUPLICATE_SESSION_HANDLED');

      if (!handled) {
        sessionStorage.setItem(
          'DUPLICATE_SESSION_HANDLED',
          'true'
        );

        alert(
          'Your session is active in another device or tab. Please login again.'
        );

        clearLoginSession();

        router.replace({ name: 'LoginPage' });
        location.reload();
      }

      return Promise.reject(new Error('Duplicate session'));
    }

    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);
